import { BigNumber } from 'bignumber.js';

export const DEFAULT_OPTION_MAX_SLIPPAGE = new BigNumber(0.5); // default to 50% slippage, WIP: to move to market's API
